<template>
  <div class="global-loading-overlay" role="status" aria-live="polite" aria-label="処理中">
    <div class="global-loading-panel">
      <div class="global-loading-spinner" aria-hidden="true"></div>
      <p class="global-loading-text">処理中です...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalLoadingOverlay'
};
</script>

<style scoped>
.global-loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(8, 18, 32, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
}

.global-loading-panel {
  min-width: 220px;
  padding: 20px 28px;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.global-loading-spinner {
  width: 44px;
  height: 44px;
  border: 4px solid #d6e2ef;
  border-top-color: #0d6efd;
  border-radius: 50%;
  animation: global-loading-spin 0.8s linear infinite;
}

.global-loading-text {
  margin: 12px 0 0;
  color: #1f2d3d;
  font-size: 14px;
  font-weight: 600;
}

@keyframes global-loading-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
